import { cx } from '@/lib/cx'

const tones = {
  muted: 'border-border text-muted',
  warning: 'border-warning text-warning',
  danger: 'border-danger text-danger',
  success: 'border-success text-success',
}

/** Small outlined status pill; tone only colors the text and border. */
export function Badge({ tone, children }: { tone: keyof typeof tones; children: string }) {
  return <span className={cx('rounded-full border px-2 py-0.5 text-xs font-medium', tones[tone])}>{children}</span>
}
